<form [formGroup]="userPassForm" (ngSubmit)="onSubmit()" *ngIf="userPassForm && editMode">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">New Password</label>
      <input type="password" class="form-control" formControlName="pass"
             [class.is-invalid]="userPassForm.get('pass')?.errors && userPassForm.get('pass')?.touched">
      <div class="invalid-feedback" *ngIf="userPassForm.get('pass')?.touched && userPassForm.get('pass')?.hasError('required')">
        Password is required
      </div>
      <div class="invalid-feedback" *ngIf="userPassForm.get('pass')?.touched && userPassForm.get('pass')?.hasError('minlength')">
        Password must be at least 6 characters
      </div>
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Confirm Email</label>
      <input type="email" class="form-control" formControlName="email1" readonly>
    </div>
    <div class="col-12">
      <button type="submit" class="btn btn-warning me-2" [disabled]="!userPassForm.valid">
        <i class="fa fa-key me-1"></i>
        Update Password
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="fa fa-times me-1"></i>
        Cancel
      </button>
    </div>
  </div>
</form>
<div *ngIf="!editMode" class="text-center py-3">
  <p class="text-muted mb-0">
    <i class="fa fa-shield-alt me-2"></i>
    Click "Change Password" to update the user's password
  </p>
</div>